import React from 'react';

import { TextBlock } from '../TextBlock/TextBlock';
import * as styles from './PartnerLegals.styles';

interface PartnerLegalsProps {
  returnAddress?: string;
  vatNumber?: string;
}

export const PartnerLegals = ({ returnAddress, vatNumber }: PartnerLegalsProps) => {
  return (
    <>
      <hr css={styles.divider} />
      <TextBlock
        footerLinkHref="https://info.notonthehighstreet.com/hc/en-us/articles/360007444693-Delivery-Information?_gl=1%2A36y4bz%2A_gcl_au%2AMjA2OTgzNTU0MC4xNzY1ODk4Njk3"
        footerLinkText="delivery policy"
        footerText="Please see notonthehighstreet.com's"
        heading="Delivery"
      />
      <hr css={styles.divider} />
      <TextBlock
        bodyText={returnAddress || ''}
        footerLinkHref="https://info.notonthehighstreet.com/hc/en-us/articles/206411168-What-is-your-returns-policy-?_gl=1*36y4bz*_gcl_au*MjA2OTgzNTU0MC4xNzY1ODk4Njk3"
        footerLinkText="returns policy"
        footerText="Please see notonthehighstreet.com's"
        heading="Returns"
      />
      <hr css={styles.divider} />
      <TextBlock
        footerLinkHref="https://www.notonthehighstreet.com/about/shopper-terms"
        footerLinkText="terms & conditions"
        footerText="Please see notonthehighstreet.com's"
        heading="Terms & conditions"
      />
      {vatNumber && (
        <>
          <hr css={styles.divider} />
          <section css={styles.vatNumberSection}>
            <p>Registered VAT No.: {vatNumber}</p>
          </section>
        </>
      )}
    </>
  );
};
